import "./Home.module.css";
import AutoMotiGalvene from "@/reusable_sections/Header";
import TurnMoreDentalLeadsIntoBookedAppointmentsAutomatically from "./sections/TurnMoreDentalLeadsIntoBookedAppointmentsAutomatically";
import CategoryCatalog from "./sections/CategoryCatalog";
import FeaturedDisplayHardware from "./sections/FeaturedDisplayHardware";
import Offerings from "./sections/Offerings";
import WhySellWithUs from "./sections/WhySellWithUs";
import CapturingTheMoment from "./sections/CapturingTheMoment";
import Footer from "@/reusable_sections/Footer";
import PartnerShowcase from "./sections/PartnerShowcase";
export default function HomePage() {
  return <div>
      <AutoMotiGalvene />
      <TurnMoreDentalLeadsIntoBookedAppointmentsAutomatically />
      <Offerings />
      <CategoryCatalog />
      <FeaturedDisplayHardware />
      <WhySellWithUs />
      <CapturingTheMoment />
      <PartnerShowcase />
      <Footer />
    </div>;
}